import AsyncStorage from '@react-native-async-storage/async-storage';
import * as FileSystem from 'expo-file-system';
import * as Sharing from 'expo-sharing';
import { API_BASE_URL } from './api';

export const pdfService = {
  download: async (commandeId: number, fileName: string): Promise<string> => {
    const token = await AsyncStorage.getItem('jwt_token');
    if (!token) {
      throw new Error('Session expirée. Veuillez vous reconnecter.');
    }

    const directory = FileSystem.documentDirectory ?? FileSystem.cacheDirectory;
    if (!directory) {
      throw new Error('Espace de stockage indisponible sur cet appareil.');
    }

    const fileUri = `${directory}${fileName}`;
    const result = await FileSystem.downloadAsync(
      `${API_BASE_URL}/api/pdf/${commandeId}`,
      fileUri,
      { headers: { Authorization: `Bearer ${token}` } }
    );

    if (result.status < 200 || result.status >= 300) {
      await FileSystem.deleteAsync(result.uri, { idempotent: true });
      throw new Error(`Le téléchargement du PDF a échoué (${result.status}).`);
    }

    if (await Sharing.isAvailableAsync()) {
      await Sharing.shareAsync(result.uri, {
        mimeType: 'application/pdf',
        dialogTitle: `Ouvrir ou enregistrer ${fileName}`,
        UTI: 'com.adobe.pdf',
      });
    }

    return result.uri;
  },
};